const Demo6Content7 = () => {
    return (
        <section id="content-7" className="content-7 wide-60 content-section division">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-md-6 order-last order-md-2">
                        <div className="txt-block left-column wow fadeInLeft">
                            <span className="section-id txt-upcase">Developer Friendly</span>
                            <h2 className="h2-xs">Powerful API for custom integrations</h2>
                            <ul className="simple-list">
                                <li className="list-item">
                                    <p className="p-lg">
                                        Automate your content pipeline. Automatically send new strings for translation and pull them back when they're ready.
                                    </p>
                                </li>
                                <li className="list-item">
                                    <p className="p-lg">
                                        Webhooks and SDKs make it easy to build custom workflows that fit your specific needs.
                                    </p>
                                </li>
                            </ul>
                            <div className="tools-list ico-40 mt-30">
                                <h6 className="h6-lg">Supported Formats:</h6>
                                {['JSON', 'XML', 'YAML', 'CSV', 'PO', 'XLIFF'].map((tech) => (
                                    <span key={tech} className="tech-badge text-black-50">
                                        {tech}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-first order-md-2">
                        <div className="content-7-img wow fadeInRight">
                            <img className="img-fluid" src="/images/demo6/dashboard-05.png" alt="content" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Content7;
